export default __webpack_public_path__ + "static/media/banana-icon.c45e9590.svg";